import { AspenPatientTasksService, PaginatedDTO_PatientTaskDTO_ } from '../client'
import { usePaginatedData } from './usePaginatedData'

export const usePatientTasks = (initialPage = 1, initialLimit = 10, initialSort = '', initialFilters = {}) => {
    return usePaginatedData<PaginatedDTO_PatientTaskDTO_>(
        AspenPatientTasksService.indexPatientTasksGet,
        initialPage,
        initialLimit,
        initialSort,
        initialFilters
    )
}
